import { render, staticRenderFns } from "./CMCourseConfig.vue?vue&type=template&id=0af4f1c0&scoped=true&lang=pug"
import script from "./CMCourseConfig.vue?vue&type=script&lang=js"
export * from "./CMCourseConfig.vue?vue&type=script&lang=js"
import style0 from "./CMCourseConfig.vue?vue&type=style&index=0&id=0af4f1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4f1c0",
  null
  
)

export default component.exports